import config from '@/config'
import axios from 'axios'

const instance = axios.create({
  baseURL: config.thailandpostmart.serverUrl,
  timeout: 30000,
  headers: config.thailandpostmart.auth
})

instance.interceptors.response.use(
  (response) => {
    if (response.data && response.data.responsecode === 400) {
      throw response
    }
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const thailandpostmartApi = {
  getCart: (userId, params) => {
    return instance.get(`/cart/user/${userId}`, { params })
  },
  addCart: (data) => {
    return instance.post('/cart/add', data)
  },
  removeCart: (data) => {
    return instance.post('/cart/remove', data)
  },
  checkoutCart: (data) => {
    return instance.post('/cart/checkout', data)
  }
}
